import { useEffect, memo, useRef, useCallback, useState } from 'react';
import { Modal } from 'antd';
import Header from '@/sub-luca-plugin/components/equity-render/header';
import EquityCards from '@/sub-luca-plugin/components/equity-render/equity-cards';
import ApplicableSubjects from '@/sub-luca-plugin/components/equity-render/applicable-subjects';
import PlaceOrder from '@/sub-luca-plugin/components/equity-render/place-order';
import EmptyData from '@/sub-luca-plugin/components/equity-render/empty-data';
import RechargeRecordModal from '@/sub-luca-plugin/components/recharge-record-modal';
import { LoadingOutlined } from '@ant-design/icons';
import { useInitEquityData, useSwitchEquity } from '@/sub-luca-plugin/components/equity-render/helper';
import { eventBusExample, queryDomExample } from '@/sub-luca-plugin/utils/class-example';
import { preventBodyScroll, recoverBodyScroll } from '@/sub-luca-plugin/utils/tools';
import './index.scss';

const EquityModal = (_: any) => {
    const initParams = useRef<{ lucaId: number; projectId: number }>();
    const { userRights, categoryTitles, canPayList, refreshData, resetData: resetEquityData } = useInitEquityData();
    const { switchEquity, applicableData, productInfo, resetData } = useSwitchEquity();
    const [visible, setVisible] = useState(false);

    const handleBuySuccess = useCallback(() => {
        const { lucaId, projectId } = initParams.current!;
        refreshData(lucaId, projectId);
    }, []);

    const handleClose = useCallback(() => {
        setVisible(false);
        resetEquityData();
        resetData();
    }, []);

    useEffect(() => {
        visible ? preventBodyScroll() : recoverBodyScroll();
    }, [visible]);

    useEffect(() => {
        eventBusExample.subscribe('EquityModal', ({ type, params }) => {
            switch (type) {
                case 'open':
                    setVisible(true);
                    initParams.current = params;
                    refreshData(params.lucaId, params.projectId);
                    break;
                default:
                    handleClose();
                    break;
            }
        });
    }, []);

    return (
        <>
            <Modal
                centered
                width={860}
                className="equity-modal"
                open={visible}
                title=""
                closable={false}
                footer={null}
                getContainer={queryDomExample.queryLucaQaRoot}
                zIndex={1900}
            >
                <Header userRights={userRights} onClose={handleClose} />
                <div className="equity-modal__content">
                    {canPayList === undefined && (
                        <div className="equity-modal__content-loading-container">
                            <span>加载中...</span>
                            <LoadingOutlined size={30} />
                        </div>
                    )}
                    {!!canPayList?.length && (
                        <>
                            <div className="equity-cards-container">
                                <EquityCards
                                    canPayList={canPayList}
                                    productId={productInfo?.productId}
                                    categoryTitles={categoryTitles}
                                    onSwitchEquity={switchEquity}
                                    title="权益说明"
                                />
                            </div>
                            <div className="rights-applicable-info-container">
                                <ApplicableSubjects applicableData={applicableData} />
                            </div>
                            <PlaceOrder
                                ininInfo={initParams.current}
                                productId={productInfo?.productId}
                                productAmount={productInfo?.amount}
                                onBuySuccess={handleBuySuccess}
                            />
                        </>
                    )}
                    {canPayList?.length === 0 && <EmptyData />}
                </div>
            </Modal>
            <RechargeRecordModal />
        </>
    );
};

export default memo(EquityModal);
